import { stats } from "../../../mocks/Cleario";

export default function EnvironmentalSection() {
  return (
    <section id="environmental" className="py-24 bg-white border-t border-transparent">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">

        {/* Header row */}
        <div className="flex flex-col lg:flex-row lg:items-end gap-10 lg:gap-24 mb-16">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-6 thick-border cartoon-shadow-sm">
              <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Doing Things Right</span>
            </div>
            <h2 className="font-black text-cl-dark leading-[1.0]" style={{ fontSize: "clamp(2.8rem, 5.5vw, 4.5rem)" }}>
              We collect it responsibly.<br />
              <span className="text-cl-green">We can prove it.</span>
            </h2>
          </div>
          <div className="lg:max-w-sm pb-1">
            <p className="text-cl-dark/60 text-base font-semibold leading-relaxed mb-6">
              Every Cleario collection comes with a licensed waste transfer note. Audited, accountable, and genuinely working to divert as much as possible from landfill.
            </p>
            <a
              href="#"
              className="inline-flex items-center gap-2 bg-cl-dark text-white font-black px-7 py-3.5 rounded-2xl text-sm cartoon-btn whitespace-nowrap"
            >
              <i className="ri-plant-line text-cl-lime"></i>
              Our green mission
            </a>
          </div>
        </div>

        {/* Stats — big numbers, clean on white */}
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-y-2 lg:divide-y-0 lg:divide-x-2 divide-transparent border-2 border-transparent rounded-3xl overflow-hidden mb-8">
          {stats.map((stat, i) => (
            <div key={i} className="py-8 px-5 lg:px-8 flex flex-col gap-1.5 bg-white">
              <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-cl-lime border-2 border-cl-dark mb-2 flex-shrink-0 cartoon-shadow-sm">
                <i className={`${stat.icon} text-cl-dark text-base`}></i>
              </span>
              <p className="font-black text-cl-dark leading-none text-2xl lg:text-4xl break-words">
                {stat.value}
              </p>
              <p className="text-cl-green font-black text-xs uppercase tracking-widest">{stat.unit}</p>
              <p className="text-cl-dark/50 text-xs font-semibold leading-relaxed mt-0.5">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* CTA bar — lime accent, contained */}
        <div className="bg-cl-lime rounded-3xl px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-5 thick-border cartoon-shadow">
          <div className="flex items-center gap-4">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-cl-dark flex-shrink-0">
              <i className="ri-heart-line text-cl-lime text-xl"></i>
            </span>
            <div>
              <p className="text-cl-dark font-black text-base mb-0.5">We donate to Make-A-Wish Foundation on every single job.</p>
              <p className="text-cl-dark/60 text-sm font-semibold">
                Proudly partnered with Make-A-Wish UK — because words aren&apos;t enough.
              </p>
            </div>
          </div>
          <a
            href="https://www.make-a-wish.org.uk"
            target="_blank"
            rel="nofollow noopener"
            className="flex-shrink-0 bg-cl-dark text-white font-black px-7 py-3.5 rounded-2xl text-sm cartoon-btn whitespace-nowrap"
          >
            See our Make-A-Wish partnership →
          </a>
        </div>

      </div>
    </section>
  );
}
